import { Loader } from "@commonlibs";
import { NumericTextFieldProps } from "ui/common/components/input/NumericTextField/NumericTextField.types";
import { PointsBalanceFieldProps } from "../PointsBalanceField";
import { useControlled } from "@commonlibs";
import usePointsBalanceValidation from "./usePointsBalanceValidation";
import usePointsBalanceHint from "./usePointsBalanceHint";
import usePointFindBy from "features/points/hooks/usePointFindBy";

export default function usePointsBalanceField({
    readonly,
    error: errorProp,
    hideError,
    validators = {},
    suffix: suffixProp,
    defaultValue = "",
    value: valueProp,
    onChange: onChangeProp,
    loading,
    name,

    ...rest
}: PointsBalanceFieldProps): NumericTextFieldProps {
    const [value, onChange] = useControlled(defaultValue, valueProp, onChangeProp);
    const { data: { decimals } = {} } = usePointFindBy();

    const { hint } = usePointsBalanceHint({ lte: validators.lte, isLoading: loading });
    const { error } = usePointsBalanceValidation({ validators, value, error: errorProp, name });

    const isLoading = loading || typeof decimals !== "number";
    const suffix = isLoading ? <Loader /> : suffixProp;

    return {
        suffix,
        readonly: readonly ?? isLoading,
        error,
        hideError: (hideError || value === "") ?? isLoading,
        placeholder: "1500",
        hint,
        value,
        onChange,
        maxDecimals: decimals,
        ...rest,
    };
}
